<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="toAddProjectClick" v-if="auth_control.have_add_auth">添加服务项目</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="序号"
		      align="center"
		      width="60"
        >
		    </el-table-column>
		    <el-table-column
		      prop="server_name"
		      label="服务项目名称"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="服务项目类型"
		      align="center"
        >
          <template slot-scope="scope">
          	<span v-if="scope.row.type === '1'">淘宝项目</span>
          	<span v-if="scope.row.type === '2'">非淘宝项目</span>
          </template>
		    </el-table-column>
		    <el-table-column
		      label="服务项目图片"
		      align="center"
        >
          <template slot-scope="scope">
             <img :src="imgDomain + scope.row.server_icon"  class="project-img">
          </template>
		    </el-table-column>
		    <el-table-column
		      prop="server_price"
		      label="服务项目金额(元)"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="message"
		      label="提醒文字"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="150"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editServiceClick(scope.row)" v-if="auth_control.have_edit_auth">编辑</span>
         	    <span class="opration-item" @click="deleteServiceClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
    </div>
    <common-dialog
    title="删除服务项目"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		   是否删除服务项目？
      </div>
		</common-dialog>
  </div>
</template>

<script>
import CommonDialog from '@/components/CommonDialog';
import { mapState, mapMutations, mapActions } from 'vuex';
import { servicelist, deleteService } from '@/api/service';

export default {
  name: 'serviceprojectmanage',
  data() {
  	return {
  		tableData: [],
  		dialogVisible: false,
      handle_row:  {},
      auth_control: {   //是否具有服务项目管理相应三级权限
        have_edit_auth: false,
        have_add_auth: false,
        have_delete_auth: false,
      }
  	}
  },
  components: {
  	CommonDialog,
  },
  computed: {
     ...mapState(['imgDomain', 'operationList']),
  },
  mounted() {
    this.getServiceList();
    this.handleThreeRules();
  },
  methods: {
  	async getServiceList() {
  		const { data, status } = await servicelist();
  		if ( status !== 200 ) return
  		this.tableData = data.data;
  	},
  	async deleteServiceClick(row) {
  		this.handle_row = row;
  		this.dialogVisible = true;
  	},
  	dialogCancelClick() {
  		this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      const { status } = await deleteService(this.handle_row.uuid);
      if (status !== 200) return
      this.dialogVisible = false;
  	},
  	dialogClose() {
  		this.dialogVisible = false;
  		this.handle_row = {};
  		this.getServiceList();
  	},
  	toAddProjectClick() {
  		this.$router.push('/service-project-manage/project-operate')
  	},
    editServiceClick(row) {
      this.$router.push({
        path: '/service-project-manage/project-operate',
        query: {
          uuid: row.uuid
        }
      })
    },
     handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        switch(true) {
          case item.menu_name.indexOf('新增') !== -1 :
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf('编辑') !== -1 :
            this.auth_control.have_edit_auth = true;
            break;
          case item.menu_name.indexOf('删除') !== -1 :
            this.auth_control.have_delete_auth = true;
            break;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 30px;
}
.table-wrap {
	margin-top: 30px;
	.operation-wrap {
		display: flex;
		justify-content: space-around;
		color: @color-text;
		.opration-item{
			cursor: pointer;
		}
	}
  .project-img {
    max-width: 200px;
    max-height: 200px;
  }
}
.dialog-body-wrap {
	text-align: center;
}
</style>
